/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_101Inputs */

const vi_carrier_status_101 = /** @type {(inputs: Carrier_Status_101Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãng huỷ lấy hàng`)
};

/**

* @param {Carrier_Status_101Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_101 = /** @type {((inputs?: Carrier_Status_101Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_101Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_101(inputs)
});